<template>
    <div class="content">
        <h2>监督员执法证</h2>
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="选择执法证:" prop="zfz">
                        <el-select v-model="form.zfz" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item>
                        <el-button type="primary" size="small" @click="submit('form')">生成</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "Layout",
    props:['code'],
    data() {
        return {
            loading:false,
            form:{},
            rules:{
                zfz:[
                    { required: true, message: '执法证不能为空', trigger: ['change','blur'] }
                ]
            },
            options:[
                {value:1,label:'新执法证'},
                {value:0,label:'旧执法证'}
            ],
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {
        this.getList()
    },
    methods: {
        async getList(){
            
        },
        submit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let that = this
                    this.$confirm("您是否确定保存当前页面数据并生成文书?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                    .then(() => {
                        that.$emit('handleBack',1)
                    })
                }
            })
        }
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
</style>